import React, {useEffect, useState} from 'react';
import './PurchaseHistoryPage.css';
import PageButton from '../../elements/PageButton/PageButton';
import Pagination from '../../elements/Pagination/Pagination';
import PurchaseHistoryItem from '../../PurchaseHistoryItem/PurchaseHistoryItem';
import {usePageAnalytics} from '../../../hooks/analytics/usePageAnalytics';
import {API_BASE} from '../../../utils/apiConfig';
import {addClassNameIfTrue} from "../../../utils/other/addClassNameIfTrue";
import {MENU_SOUND_MANAGER} from "../../../scenes/MenuSoundManager";

const PAGE_ID = 'PurchaseHistoryPage';
const PAGE_SIZE = 10;

function PurchaseHistoryPage({isAllPurchases, userId, userName, onBack, onUserClick}) {
  const [purchases, setPurchases] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [cache, setCache] = useState(new Map());

  usePageAnalytics('PurchaseHistoryPage');

  useEffect(() => {
    const fetchPurchases = async () => {
      setLoading(true);
      setError(null);

      const cacheKey = `${isAllPurchases ? 'all' : userId}_${page}`;
      const cached = cache.get(cacheKey);
      if (cached) {
        setPurchases(cached.purchases);
        setTotalPages(cached.totalPages);
        setLoading(false);
        return;
      }

      try {
        const url = isAllPurchases
          ? `${API_BASE}/admin/purchases?limit=${PAGE_SIZE}&page=${page}`
          : `${API_BASE}/users/${userId}/purchases?limit=${PAGE_SIZE}&page=${page}`;
        const res = await fetch(url, {
          credentials: 'include',
        });
        if (!res.ok) throw new Error('Failed to fetch purchase history');
        const data = await res.json();
        setPurchases(data.purchases || []);
        setTotalPages(data.totalPages || 1);
        setCache((prev) => {
          const next = new Map(prev);
          next.set(cacheKey, data);
          return next;
        });
      } catch (e) {
        console.error('Purchase history error', e);
        setError('Не удалось загрузить историю покупок');
      } finally {
        setLoading(false);
      }
    };

    fetchPurchases();
  }, [page, cache, userId, isAllPurchases]);

  const handlePageChange = (newPage) => {
    MENU_SOUND_MANAGER.playMenuButtonClick();
    setPage(newPage);
  };

  let title;
  if (isAllPurchases) {
    title = 'Все покупки';
  } else {
    title = 'История покупок';
  }

  const isUserNameShown = userName && !isAllPurchases

  return (
    <>
      <h1
        className={`admin-user-profile-title ${addClassNameIfTrue(!isUserNameShown, 'history-page-title-margin-bottom')}`}
      >{title}</h1>

      {isUserNameShown && (
        <h1 className="admin-user-profile-name">{userName}</h1>
      )}

      {loading && <p className="purchase-history-page-status">Загрузка...</p>}
      {error && <p className="purchase-history-page-status purchase-history-page-status_error">{error}</p>}

      {!loading && !error && (
        <>
          {purchases.length === 0 ? (
            <p className="purchase-history-page-status">Пока нет покупок</p>
          ) : (
            <>
              <div className="purchase-history-page-list">
                {purchases.map((purchase, index) => (
                  <PurchaseHistoryItem
                    key={purchase._id}
                    purchase={purchase}
                    showUserName={isAllPurchases}
                    onClick={isAllPurchases ? () => onUserClick(purchase.userId, purchase.userName) : undefined}
                    pageId={PAGE_ID}
                    buttonId={`purchase_${index}`}
                  />
                ))}
              </div>
              <Pagination currentPage={page} totalPages={totalPages} onPageChange={handlePageChange}/>
            </>
          )}
        </>
      )}

      <div className="main-menu-buttons purchase-history-page-buttons">
        <PageButton onClick={onBack} pageId={PAGE_ID} buttonId="back">
          Назад
        </PageButton>
      </div>
    </>
  );
}

export default PurchaseHistoryPage;
